<template>
    <div class="App">
        <ak-header
            v-if="$route.matched.length && !$route.meta.noNav"
        ></ak-header>
        <router-view />
    </div>
</template>
<style lang="scss" src="./assets/scss/app.scss"></style>
<script>
import AkHeader from '@/components/AkHeader';
export default {
    name: 'App',
    components: {
        AkHeader
    }
};
</script>
<style lang="scss">
html,
body {
    background: #f5f5f5;
}

.App {
    overflow: hidden;
}

pre {
    white-space: pre-wrap;
    word-wrap: break-word;
    max-width: 830px;
}

.el-table--striped .el-table__body tr.el-table__row--striped td {
    background: #f5f5f5;
}
.flex-info {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
}
.full-screen {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    &__main {
        flex: 1;
        overflow-y: auto;
    }
}
</style>
